export default function isValidYear(year, currentYear) {
    return (year >= (currentYear - 100)) && (year <= (currentYear + 100));
}
